import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreTableComponent } from './core-table.component';
import { AgGridModule } from 'ag-grid-angular';
import {
	BtnCellEditRendererComponent,
	BtnCellRendererComponent,
	EditableCellRendererComponent,
	BtnCellClickRendererComponent,
	BtnIconCellRendererComponent,
	BtnIconBooleanComponent,
	StatusCellRendererComponent,
	TranslateRendererComponent,
	DiplomaSupplementDownloadCellRendererComponent,
	CareerYearBoxesCellRendererComponent,
	CareerOperationsCellRendererComponent,
	ChipsCellRendererComponent,
	ProgressBarCellRendererComponent,
} from './components';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreCommonModule } from '../../common.module';
import { MobileRendererComponent } from './components/mobile-renderer/mobile-renderer.component';
import { TranslateModule } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TableStateService } from 'app/@core/services/table-state.service';
import { TagComponent } from '@core/components/ui/tag.component';

@NgModule({
	declarations: [
		CoreTableComponent,
		BtnCellRendererComponent,
		BtnCellEditRendererComponent,
		EditableCellRendererComponent,
		BtnCellClickRendererComponent,
		BtnIconCellRendererComponent,
		TranslateRendererComponent,
		MobileRendererComponent,
		BtnIconBooleanComponent,
		StatusCellRendererComponent,
		DiplomaSupplementDownloadCellRendererComponent,
		CareerYearBoxesCellRendererComponent,
		CareerOperationsCellRendererComponent,
		ChipsCellRendererComponent,
		ProgressBarCellRendererComponent,
	],
	imports: [
		CommonModule,
		AgGridModule,
		NgbModule,
		CoreCommonModule,
		TranslateModule,
		FontAwesomeModule,
		NgSelectModule,
		FormsModule,
		TagComponent,
	],
	providers: [TableStateService],
	exports: [
		CoreTableComponent,
		BtnCellRendererComponent,
		BtnCellEditRendererComponent,
		EditableCellRendererComponent,
		BtnCellClickRendererComponent,
		BtnIconCellRendererComponent,
		TranslateRendererComponent,
		MobileRendererComponent,
		BtnIconBooleanComponent,
		StatusCellRendererComponent,
		DiplomaSupplementDownloadCellRendererComponent,
		CareerYearBoxesCellRendererComponent,
		CareerOperationsCellRendererComponent,
		ChipsCellRendererComponent,
		ProgressBarCellRendererComponent,
	],
})
export class CoreTableModule {}
